import Typography from "@mui/material/Typography";
import CCOLink from "../../fundamentals/CCOLink";
import Box from "@mui/material/Box";

export interface NavigationProps {
    navItem: any,
    height: string,
    isActive: boolean
}

function C091EasyLangSubTeaser(props: NavigationProps) {
    return <CCOLink target={props.navItem} className={"easy-lang-teaser-link"}>
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            background: props.isActive ? 'var(--sos-main)' : 'var(--background-white)',
            height: props.height,
            '.easy-lang-teaser-link:hover &': {
                background: 'var(--sos-main)'
            }
        }}>
            <Box id={`child-${props.navItem.id}`}
                 sx={{
                     display: 'flex',
                     alignItems: 'center',
                 }}>
                <Typography
                    sx={{
                        fontSize: '18px',
                        padding: '16px',
                        color: props.isActive ? 'white' : 'var(--primary-text)',
                        '.easy-lang-teaser-link:hover &': {
                            color: 'white',
                            textDecoration: props.isActive ? 'none' : 'underline'
                        }
                    }}
                    data-cypress={`mainNavigationSpan${props.navItem.id}`}
                    variant={"navigationItem"}>
                    {props.navItem.teaserTitle ?? props.navItem.name}
                </Typography>
            </Box>
        </Box>
    </CCOLink>
}

export default C091EasyLangSubTeaser;